import { Action, State } from "./types";

export const rootReducer = (state: State, action: Action) => {
  switch (action.type) {
    case "setDataMarkers": {
      return {
        ...state,
        dataMarkers: action.data
      }
    }
    case "setDataList": {
      return {
        ...state,
        dataList: action.data
      }
    }
    case "setShowSearchInThisArea": {
      return {
        ...state,
        showSearchInThisArea: action.data
      }
    }
    case "setExtraMarker": {
      if (action.mapContext) {
        if (state.extraMarker) {
          action.mapContext.removeLayer(state.extraMarker.marker);
        }
        if (action.data) {
          action.mapContext.addLayer(action.data.marker);
        }
        return {
          ...state,
          extraMarker: action.data
        }
      }
      return state
    }
    case "setPreviousApp": {
      return {
        ...state,
        previousApp: action.data
      }
    }
    case "setGeohash": {
      return {
        ...state,
        geohash: action.data
      }
    }
    case "setIsMapMoving": {
      return {
        ...state,
        isMapMoving: action.data
      }
    }
    case "setRefetch": {
      return {
        ...state,
        refetch: action.data
      }
    }
    case "setCurrentPage": {
      return {
        ...state,
        currentPage: action.data,
      }
    }
    case "setTotalPages": {
      return {
        ...state,
        totalPages: action.data
      }
    }
    default: {
      throw Error ("Error - unknown action type");
    }
  }
}
